"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstructorFile = exports.InstructorFileData = void 0;
var http_client_1 = require("./http_client");
var utils_1 = require("./utils");
var InstructorFileData = /** @class */ (function () {
    function InstructorFileData(_a) {
        var pk = _a.pk, project = _a.project, name = _a.name, size = _a.size, last_modified = _a.last_modified;
        this.pk = pk;
        this.project = project;
        this.name = name;
        this.size = size;
        this.last_modified = last_modified;
    }
    return InstructorFileData;
}());
exports.InstructorFileData = InstructorFileData;
var InstructorFile = /** @class */ (function (_super) {
    __extends(InstructorFile, _super);
    function InstructorFile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InstructorFile.subscribe = function (observer) {
        InstructorFile._subscribers.add(observer);
    };
    InstructorFile.unsubscribe = function (observer) {
        InstructorFile._subscribers.delete(observer);
    };
    InstructorFile.get_all_from_project = function (project_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response, files;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/projects/" + project_pk + "/instructor_files/")];
                    case 1:
                        response = _a.sent();
                        files = response.data.map(function (file_data) { return new InstructorFile(file_data); });
                        utils_1.sort_by_name(files);
                        return [2 /*return*/, files];
                }
            });
        });
    };
    InstructorFile.get_by_pk = function (instructor_file_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/instructor_files/" + instructor_file_pk + "/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new InstructorFile(response.data)];
                }
            });
        });
    };
    InstructorFile.create = function (project_pk, name, content, on_upload_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var form_data, response, new_file;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        form_data = new FormData();
                        form_data.append('file_obj', content, name);
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/projects/" + project_pk + "/instructor_files/", form_data, { on_upload_progress: on_upload_progress })];
                    case 1:
                        response = _a.sent();
                        new_file = new InstructorFile(response.data);
                        InstructorFile.notify_instructor_file_created(new_file);
                        return [2 /*return*/, new_file];
                }
            });
        });
    };
    InstructorFile.notify_instructor_file_created = function (instructor_file) {
        var e_1, _a;
        try {
            for (var _b = __values(InstructorFile._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_instructor_file_created(instructor_file);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    InstructorFile.prototype.get_content = function (on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get_file("/instructor_files/" + this.pk + "/content/", { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    InstructorFile.prototype.set_content = function (content, on_upload_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var form_data, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        form_data = new FormData();
                        form_data.append('file_obj', content, this.name);
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().put("/instructor_files/" + this.pk + "/content/", form_data, { on_upload_progress: on_upload_progress })];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, response.data);
                        InstructorFile.notify_instructor_file_content_changed(this, content);
                        return [2 /*return*/];
                }
            });
        });
    };
    InstructorFile.notify_instructor_file_content_changed = function (instructor_file, new_content) {
        var e_2, _a;
        try {
            for (var _b = __values(InstructorFile._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_instructor_file_content_changed(instructor_file, new_content);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    InstructorFile.prototype.rename = function (new_name) {
        return __awaiter(this, void 0, void 0, function () {
            var old_name, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        old_name = this.name;
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().put("/instructor_files/" + this.pk + "/name/", { name: new_name })];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, response.data);
                        InstructorFile.notify_instructor_file_renamed(this, old_name);
                        return [2 /*return*/];
                }
            });
        });
    };
    InstructorFile.notify_instructor_file_renamed = function (instructor_file, old_name) {
        var e_3, _a;
        try {
            for (var _b = __values(InstructorFile._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_instructor_file_renamed(instructor_file, old_name);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    InstructorFile.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var original_name, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        original_name = this.name;
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/instructor_files/" + this.pk + "/")];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, response.data);
                        if (this.name !== original_name) {
                            InstructorFile.notify_instructor_file_renamed(this, original_name);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    InstructorFile.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().delete("/instructor_files/" + this.pk + "/")];
                    case 1:
                        _a.sent();
                        InstructorFile.notify_instructor_file_deleted(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    InstructorFile.notify_instructor_file_deleted = function (instructor_file) {
        var e_4, _a;
        try {
            for (var _b = __values(InstructorFile._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_instructor_file_deleted(instructor_file);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    InstructorFile._subscribers = new Set();
    return InstructorFile;
}(InstructorFileData));
exports.InstructorFile = InstructorFile;
//# sourceMappingURL=instructor_file.js.map